<template>
  <div>
    <vx-card>
      <Automobile :subjectPermission="subjectPermission" />
    </vx-card>
  </div>
</template>
<script>
import Automobile from './endorsement/Automobile.vue';
export default {
  name: 'endorsement-configs',
  components: { Automobile },
  data() {
    return {
      subjectPermission: 'Endosso Automóvel',
    };
  },
};
</script>
<style></style>
